import { render, staticRenderFns } from "./LinkAplifisaToUser.vue?vue&type=template&id=72e8b274&"
import script from "./LinkAplifisaToUser.vue?vue&type=script&lang=js&"
export * from "./LinkAplifisaToUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports